var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4006 3.35205C11.0672 3.35205 5.73389 4.01872 5.73389 8.68538V21.3521C5.73389 22.6187 6.24055 23.7654 7.06722 24.6054V27.3521C7.06722 28.0854 7.66722 28.6854 8.40055 28.6854H9.73389C10.4672 28.6854 11.0672 28.0854 11.0672 27.3521V26.0187H21.7339V27.3521C21.7339 28.0854 22.3339 28.6854 23.0672 28.6854H24.4006C25.1339 28.6854 25.7339 28.0854 25.7339 27.3521V24.6054C26.5606 23.7654 27.0672 22.6187 27.0672 21.3521V8.68538C27.0672 4.01872 22.2939 3.35205 16.4006 3.35205ZM16.4006 6.01872C21.3472 6.01872 23.2406 6.63205 23.9606 7.35205H8.97389C9.77389 6.65872 11.7072 6.01872 16.4006 6.01872ZM24.4006 20.6854C24.4006 22.1521 23.2006 23.3521 21.7339 23.3521H11.0672C9.60055 23.3521 8.40055 22.1521 8.40055 20.6854V16.6854H24.4006V20.6854ZM24.4006 14.0187H8.40055V10.0187H24.4006V14.0187Z",
    fill: "#8385DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7339 22.0187C12.8385 22.0187 13.7339 21.1233 13.7339 20.0187C13.7339 18.9141 12.8385 18.0187 11.7339 18.0187C10.6293 18.0187 9.73389 18.9141 9.73389 20.0187C9.73389 21.1233 10.6293 22.0187 11.7339 22.0187Z",
    fill: "#8385DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0672 22.0187C22.1718 22.0187 23.0672 21.1233 23.0672 20.0187C23.0672 18.9141 22.1718 18.0187 21.0672 18.0187C19.9627 18.0187 19.0672 18.9141 19.0672 20.0187C19.0672 21.1233 19.9627 22.0187 21.0672 22.0187Z",
    fill: "#8385DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.733d93aeede229e62b7bdb690fe2dd06.svg";
export { ForwardRef as ReactComponent };